"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const common_1 = require("@Const/common");
const WritersSection = (props) => {
    const { writers } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "section-header" },
            react_1.default.createElement("img", { src: common_1.ICONS.recordingWriters, alt: 'Recording Writers' }),
            react_1.default.createElement("h5", null, "Writers")),
        react_1.default.createElement("div", { className: 'details writers-details' },
            react_1.default.createElement("div", { className: 'vertical-detail' },
                react_1.default.createElement("p", { className: "underline writer-label" }, "Writer Name"),
                writers.length === 0 ? (react_1.default.createElement("p", { className: "not-available" }, "Not Available")) : (writers.map((writer, idx) => (react_1.default.createElement("p", { className: "semi-bold", key: idx }, writer))))))));
};
exports.default = WritersSection;
